<template>
  <div v-if="vo" class="space-between-y">
    <info :infos="[
        {label:'订单ID',value:vo.id},
        {label:'订单编号',value:vo.number},
        {label:'价格',value:vo.price},
        {label:'VIP方案ID',value:vo.planId},
        {label:'VIP方案名称',value:vo.planName},
        {label:'支付状态',value:vo.payStatus},
        {label:'支付时间',value:vo.payTime},
        {label:'用户ID',value:vo.miuUserId},
        {label:'用户名',value:vo.miuUserName},
        {label:'提交时间',value:vo.createTime}
    ]"></info>

    <el-collapse style="margin-top: 20px" v-model="activeName" accordion>
      <el-collapse-item title="微信预付单创建记录" name="1">
        <el-table :data="vo.prepaies" stripe border empty-text="无记录">
          <el-table-column label="#" type="index"></el-table-column>
          <el-table-column prop="outTradeNo" label="订单编号"></el-table-column>
          <el-table-column prop="amount" label="金额">
            <template slot-scope="scope">
              ￥{{ scope.row.amount.toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="description" label="支付描述">

          </el-table-column>
          <el-table-column prop="prepayId" label="预付单号"></el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
          <el-table-column prop="expired" label="是否过期">
            <template slot-scope="scope">
              {{ scope.row.expired ? '是' : '否' }}
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
      <el-collapse-item title="微信支付记录" name="2">
        <div v-if="vo.wxPayRecord">
          <info :infos="[
              {label:'创建时间',value:vo.wxPayRecord.createdAt},
              {label:'更新时间',value:vo.wxPayRecord.updatedAt},
              {label:'金额',value:vo.wxPayRecord.amount},
              {label:'微信支付单号',value:vo.wxPayRecord.transactionId},
              {label:'商户订单号',value:vo.wxPayRecord.outTradeNo},
              {label:'支付状态',value:vo.wxPayRecord.payStatus},
              {label:'累积查询支付状态次数',value:vo.wxPayRecord.payCheckedCount},
              {label:'最近查询支付状态时间',value:vo.wxPayRecord.payLastCheckedTime},
              {label:'支付成功时间',value:vo.wxPayRecord.paySuccessTime},
              {label:'应用客户端',value:vo.wxPayRecord.appClient}
          ]"></info>
        </div>
        <div v-else class="info-text">暂无支付记录</div>
      </el-collapse-item>
    </el-collapse>


    <div v-if="vo.payStatus === 'SUCCESS'" class="order-use">
      <div>订单核销状态：</div>
      <div v-if="vo.used">已核销</div>
      <div v-else>未核销</div>
    </div>

    <div class="container-center">
      <el-button @click="useOrder" v-if="!vo.used" type="primary">核销订单</el-button>
    </div>

  </div>
</template>

<script>
import {vip} from "@/api/miu/vip";
import Info from "@/components/system/Info.vue";
import {msg} from "@/assets/js/my-vue-element-ui-js";

export default {
  name: 'MiuVipOrderDetail',
  components: {Info},
  props: {
    id: Number
  },

  data() {
    return {
      vo: null,

      activeName: '1'
    };
  },

  created() {
    this.getData();
  },

  methods: {
    useOrder() {
      this.$confirm("确定核销订单吗？将根据订单自动创建或者续费下单用户VIP").then(() => {
        vip.order.use(this.id).then(res => {
          msg(res, this);
          if (res.code === 200) {
            this.getData();
          }
        })
      })
    },

    getData() {
      vip.order.detail(this.id).then(res => {
        this.vo = res.data;
      })
    },
  },


};
</script>

<style scoped>

.order-use {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  background: #f3f3f3;
  border-radius: 6px;
  padding: 7px 0;
  color: #4c4c4c;
}

</style>
